import { render, staticRenderFns } from "./CommunicationEmailMetrics.vue?vue&type=template&id=62266c0e&scoped=true"
import script from "./CommunicationEmailMetrics.vue?vue&type=script&lang=ts"
export * from "./CommunicationEmailMetrics.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62266c0e",
  null
  
)

export default component.exports